import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {mapStatePropertiesMixin} from '@aofl/map-state-properties-mixin';
import {i18nMixin} from '@aofl/i18n-mixin';
import translations from '../../i18n';
import {storeInstance} from '@aofl/store/dist/legacy';
import {ApiService} from '@modules/api-service';
import {userJobs} from '@modules/user-jobs';
import {RosterUtils} from '@modules/roster-utils';

/**
 * @summary RosterExportLink
 * @extends {mapStatePropertiesMixin(i18nMixin(AoflElement))}
 */
@customElement('roster-export-link')
class RosterExportLink extends mapStatePropertiesMixin(i18nMixin(AoflElement)) {
  /**
   * Creates an instance of RosterExportLink.
   */
  constructor() {
    super();

    this.storeInstance = storeInstance;
    this.translations = translations;
  }

  /**
   * @readonly
   */
  static is = 'roster-export-link';

  @property({type: Boolean, attribute: false})
  disableExportLink = false;

  async exportAll() {
    this.disableExportLink = true;
    try {
      userJobs.pause();
      await ApiService.rosterExportJob();
      userJobs.getJobs();
    } catch (e) {
    }
    this.disableExportLink = false;
  }

  async getRosterTemplate() {
    await RosterUtils.getRosterTemplate();
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {template, styles: [styles]}
    });
  }
}

export default RosterExportLink;
